import { useMemo } from 'react'

import { countries } from '@ems/contracts/countries'

import { Combobox } from '#ui/patterns/combobox.tsx'

/**
 * A country, by name, stored as its ISO 3166-1 alpha-2 code.
 *
 * The list is CLDR's through `Intl.DisplayNames` (`@ems/contracts/countries`) — the same list the
 * API validates against, so a country this offers is one the server accepts. Searchable by name
 * or code: "sing" and "SG" both find Singapore.
 */
export function CountrySelect({
  value,
  onValueChange,
  placeholder = 'Choose a country…',
  ...rest
}: {
  value: string
  onValueChange: (value: string) => void
  placeholder?: string
  disabled?: boolean | undefined
  className?: string | undefined
  id?: string | undefined
  'aria-label'?: string
  'aria-describedby'?: string | undefined
  'aria-invalid'?: boolean
}) {
  const options = useMemo(
    () =>
      countries().map((country) => ({
        value: country.code,
        label: country.name,
        hint: country.code,
      })),
    [],
  )

  return (
    <Combobox
      {...rest}
      value={value}
      onValueChange={onValueChange}
      options={options}
      placeholder={placeholder}
      searchPlaceholder="Search countries…"
      emptyText="No country matches."
    />
  )
}
